import { PlusCircleOutlined } from '@ant-design/icons';
import { Tag, Button, Modal, Form, Input, message } from 'antd';
import { FormInstance } from 'antd/lib/form/hooks/useForm';
import React, { FC, useState, useMemo } from 'react';
import * as uuid from 'uuid';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import { hintChildren } from '@/presentation/components/hint-text/hintText';
import { ModalIconType, ModalMsg, ModalType } from '@/presentation/components/modal-msg';
import { TdsSearchValueStorageType } from '@/presentation/components/tds-form/type';
import { useStores } from '@/presentation/store';
import styles from './save-search.module.scss';

interface IProps {
  searchValues?: TdsSearchValueStorageType;
  setSearchValues?: (valueList: TdsSearchValueStorageType) => void;
  form?: FormInstance|null;
  onFinish: (value: Record<string, any>) => void;
  isCompareOpen?: boolean;
  onSave?: () => void;
}
export const TdsSearchHistory: FC<IProps> = (props) => {
  const {
    searchValues,
    setSearchValues,
    form: filterForm,
    isCompareOpen,
  } = props;
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const { isFreeProduct } = useStores().ProductStore;

  const isFree = isFreeProduct();

  const tagOnClose = (id: string) => {
    const currentTag = searchValues?.find(item => item.id === id);
    ModalMsg({
      type: ModalType.CONFIRM,
      typeIcon: ModalIconType.INFO,
      content: `您确定要删除“${currentTag?.name}”这条记录吗？`,
      onOk: () => {
        setSearchValues?.(searchValues?.filter?.(item => item.id !== id) || []);
      },
    });
  };
  const modalCancel = () => {
    setVisible(false);
    form.resetFields();
  };
  const modalOk = async () => {
    try {
      const modalValue = await form.validateFields();
      const filterValue = filterForm?.getFieldsValue(true);
      setSearchValues?.([...(searchValues || []),
        { id: uuid.v4(), name: modalValue?.name?.replace?.(/\s*/g, ''), values: { ...filterValue, isCompareOpen } }]);
      filterForm?.submit();
      modalCancel();
    } catch (e) {

    }
  };
  const searchFilterList = useMemo(() => searchValues
    ?.filter(item => !!item?.values?.isCompareOpen === !!isCompareOpen), [searchValues, isCompareOpen]);
  const showModal = () => {
    if (searchFilterList && searchFilterList?.length > 9) {
      message.error('已满10个，请删除后再重试');
      return;
    }
    setVisible(true);
  };
  const applyCaching = (values: Record<string, any>) => {
    const { isCompareOpen, ...res } = values;
    filterForm?.resetFields();
    filterForm?.setFieldsValue(res);
    filterForm?.submit();
  };

  return <div className={styles.saveSearch}>
    {searchFilterList?.slice?.(0, 10)?.map?.((item, index) => hintChildren(<Tag onClose={(e) => {
      e.preventDefault();
      tagOnClose(item.id);
    }
      } key={index}
        closable
        onClick={() => applyCaching(item.values)}
        className={styles.tag}
        title={item.name}>
          <span className={styles.tagContent}>{item.name}</span>
      </Tag>, item.name))}
      <Button
        className={styles.triggerBtn}
        disabled={isFree}
        onClick={showModal}
        icon={<PlusCircleOutlined/>}
      >保存记录</Button>
    <Modal
      closeIcon={<IconClose/>}
      className={styles.modal}
      maskClosable={false}
      visible={visible} title={'保存记录'}
      onCancel={modalCancel}
      onOk={modalOk}
      cancelButtonProps={{
        className: styles.closeButton,
      }}
    >
      <Form form={form}>
        <Form.Item label={'记录名称'} name={'name'} rules={[{ required: true, message: '名称不能为空!' }]}>
          <Input placeholder={'请输入内容'}/>
        </Form.Item>
      </Form>
    </Modal>
  </div>;
};
